import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import {
  SwitchConfigType,
  defaultSwitchConfig,
  validateSwitchConfig,
  getSwitchPreviewText,
} from './schema';
import { SwitchConfig } from './SwitchConfig';
import { SwitchNode, switchVisualDefinition } from './SwitchNode';

export { SwitchNode } from './SwitchNode';
export { SwitchConfig } from './SwitchConfig';
export type { SwitchConfigType, SwitchCaseType } from './schema';

/** Full definition for the registry */
export const switchDefinition: NodeDefinition<SwitchConfigType> = {
  ...switchVisualDefinition,
  category: 'flow',
  paletteGroup: 'Flow Control',
  NodeComponent: SwitchNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: SwitchConfig,
  defaultConfig: () => ({ ...defaultSwitchConfig }),
  validateConfig: validateSwitchConfig,
  getPreviewText: getSwitchPreviewText,
};
